<!-- intro-section.component.html -->
<section class="intro-section {{ sectionClass }}">
  <h1 class="headline">Habit Heroes</h1>
  <div class="container">
    <ng-content></ng-content>
  </div>
</section>

